import { stringToDate, dateToday } from 'helpers/date';
import { isEmptyObject } from 'helpers/object';
import { MARKETPLACE_STATE, TYPE_VEHICLE_DESCRIPTION } from 'store/enums';

const filterRangePrice = (item, filters) => {
  const [rangePriceFrom, rangePriceTo] = filters.rangePrice;
  let rangePriceFromNormalized;
  let rangePriceToNormalized;

  if (rangePriceFrom === '<300') {
    rangePriceFromNormalized = 0;
  } else if (rangePriceFrom === '>900') {
    rangePriceFromNormalized = 901;
  } else {
    rangePriceFromNormalized = parseInt(rangePriceFrom, 10);
  }
  if (rangePriceTo === '<300') {
    rangePriceToNormalized = 299;
  } else if (rangePriceTo === '>900') {
    rangePriceToNormalized = 999999;
  } else {
    rangePriceToNormalized = parseInt(rangePriceTo, 10);
  }
  return item.monthFee >= rangePriceFromNormalized && item.monthFee <= rangePriceToNormalized;
};

const filterText = (item, filters) => {
  let matched = true;
  if (filters.filter) {
    let textFilters = filters.filter.split(' ');
    textFilters = textFilters.filter(e => e !== '');
    const textFiltersMatched = new Array(textFilters.length).fill(false);
    textFilters.forEach((text, index) => {
      let attributesForSearch = Object.values(item);
      if (item.value) {
        attributesForSearch = [...Object.values(item), ...Object.values(item.value)];
      }
      if (item.car) {
        attributesForSearch = [...Object.values(item), ...Object.values(item.car)];
      }
      attributesForSearch.forEach(column => {
        const regExp = new RegExp(`${text.toLowerCase()}`);
        if (column) {
          const matchValue = column
            .toString()
            .toLowerCase()
            .match(regExp);
          if (matchValue && matchValue.length > 0) {
            textFiltersMatched[index] = true;
          }
        }
      });
    });
    textFiltersMatched.forEach(textFilterMatched => {
      if (textFilterMatched === false) {
        matched = false;
      }
    });
    return matched;
  }
  return true;
};

const filterMarketplace = (campaign, filter) => {
  let result = !filter;
  if (campaign.marketplacePublication) {
    campaign.marketplacePublication.forEach(item => {
      if (item.label === filter && item.value === MARKETPLACE_STATE.PUBLICATION) {
        result = true;
      }
    });
  }
  return result;
};

const filterBodyStyle = (item, filters) => {
  const bodyStyle = filters.bodyStyle?.value;
  if (bodyStyle) {
    return item.car.bodyStyle.toLowerCase() === bodyStyle.toLowerCase();
  }
  return true;
};

const filterTypeVehicle = (item, filters) => {
  const typeVehicle = filters.typeVehicle;
  if (item.campaignType === null) return false;
  if (typeVehicle !== TYPE_VEHICLE_DESCRIPTION.ALL) {
    return item.campaignType ? item.campaignType === typeVehicle : true;
  }
  return true;
};

export const filterCampaigns = (filters, campaigns) =>
  // const typeVehicleFilter = filters.typeVehicle;

  campaigns.filter(item => {
    const marketplaceOk = filterMarketplace(item, filters.filterMarketplace);
    const rangePriceOk = filterRangePrice(item, filters);
    const bodyStyleOk = filterBodyStyle(item, filters);
    const typeVehicleOk = filterTypeVehicle(item, filters);
    const textOk = filterText(item, filters);
    return textOk && bodyStyleOk && typeVehicleOk && rangePriceOk && marketplaceOk;
  });

export const filterCustomers = (filters, customers) =>
  customers.filter(item => {
    const textOk = filterText(
      {
        nameCustomer: item.nameCustomer
      },
      filters
    );
    return textOk;
  });

export const filterCampaignsByVisibility = (visibility, campaigns) => {
  const today = dateToday();
  return campaigns.filter(campaign => {
    if (visibility === 'active') {
      const a = stringToDate(campaign.toDateInvisibility) >= today;
      return a;
    }
    const b = stringToDate(campaign.toDateInvisibility) < today;
    return b;
  });
};

export const getQueryFilters = filters => {
  if (!filters || isEmptyObject(filters)) return '';
  let query = '';
  // eslint-disable-next-line complexity
  Object.entries(filters).forEach(filter => {
    if (
      Array.isArray(filter[1].value) &&
      filter[1].dataType === 'Range' &&
      filter[1].value.length
    ) {
      const queryFilter = filter[1].query
        .replace('#value1#', filter[1].value[0])
        .replace('#value2#', filter[1].value[1]);
      query = query.concat(`&${queryFilter}`);
    }
    if (
      Array.isArray(filter[1].value) &&
      filter[1].dataType === 'Array' &&
      filter[1].value.length
    ) {
      if (!filter[1].value.includes('TODOS')) {
        const queryFilter = filter[1].query.replace('#values#', filter[1].value);
        query = query.concat(`&${queryFilter}`);
      }
      if (filter[1].value.includes('TODOS') && filter[1].query === 'campaignType[eqs]=#values#') {
        query = query.concat('&format[eqs]=collapse');
      }
    }
    if (typeof filter[1].value === 'string' && filter[1].value) {
      const queryFilter = filter[1].query.replace('#value#', filter[1].value);
      query = query.concat(`&${queryFilter}`);
    }
  });
  return query;
};

export const buildQuery = filters => {
  const queryParams = Object.entries(filters)
    // eslint-disable-next-line no-unused-vars
    .filter(([_, filter]) => filter.value.trim() || '')
    // eslint-disable-next-line no-unused-vars
    .map(([_, filter]) => filter.query.replace('#value#', encodeURIComponent(filter.value)))
    .join('&');

  return queryParams ? `?${queryParams}` : '';
};
